export const PQI_REFERRALS_QUERY_KEYS = {
  GET_PQI_REFERRALS: 'GET_PQI_REFERRALS',
  GET_PQI_REFERRAL: 'GET_PQI_REFERRAL',
  CREATE_PQI_REFERRAL: 'CREATE_PQI_REFERRAL',
  UPDATE_PQI_REFERRAL: 'UPDATE_PQI_REFERRAL',
};